import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import ArrowIcon from 'dibs-icons/exports/ArrowRight';

import styles from './SbSharedContentModuleBanner.scss';

const DEFAULT_MAX_IMG_WIDTH = 1126;

function SbSharedContentModuleBannerComponent({ browseContentModule, renderImage }) {
    const { photo, title, subtitle, description, link, linkText } = browseContentModule;

    const renderImageProps = {
        photo,
        src: `${photo}?width=${DEFAULT_MAX_IMG_WIDTH}`,
        imgClassName: styles.image,
        alt: title || subtitle || '',
    };

    return (
        <div className={styles.wrapper}>
            {photo && <div className={styles.imgWrapper}>{renderImage(renderImageProps)}</div>}
            <div className={styles.moduleWrapper}>
                <div className={styles.module}>
                    {title && <div className={styles.title}>{title}</div>}
                    {subtitle && <div className={styles.subtitle}>{subtitle}</div>}

                    {description && (
                        <div
                            className={styles.description}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}

                    {link && linkText && (
                        <a href={link} className={styles.link}>
                            {linkText}
                            <ArrowIcon className={styles.arrow} />
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}

SbSharedContentModuleBannerComponent.propTypes = {
    browseContentModule: PropTypes.object.isRequired,
    renderImage: PropTypes.func.isRequired,
};

export const SbSharedContentModuleBanner = createFragmentContainer(
    SbSharedContentModuleBannerComponent,
    {
        browseContentModule: graphql`
            fragment SbSharedContentModuleBanner_browseContentModule on ContentModuleBanner {
                photo
                title
                subtitle
                description
                link
                linkText
            }
        `,
    }
);
